import axios from "axios";
import api from ".";
import constant from "../constant";
export async function getCountries() {
  try {
    const response = await api.get(`/country`);
    if (response) return response;
    else throw new Error("Could not get country");
  } catch (err) {
    console.log(err);
    return err.response;
  }
}
export async function getSectors() {
  try {
    const response = await api.get(`/sector`);
    if (response) return response;
    else throw new Error("Could not get sector");
  } catch (err) {
    console.log(err);
    return err.response;
  }
}
export async function getEmpCount() {
  try {
    const response = await api.get(`/employee_count`);
    if (response) return response;
    else throw new Error("Could not get employee_count");
  } catch (err) {
    console.log(err);
    return err.response;
  }
}
export async function getIndustries() {
  try {
    const response = await api.get(`/industry`);
    if (response) return response;
    else throw new Error("Could not get industry");
  } catch (err) {
    console.log(err);
    return err.response;
  }
}
export async function sendOTPtoEmail(data) {
  try {
    let response;
    await api
      .post("/user/initiate", data)
      .then((data) => {
        console.log(data);
        response = data;
      })
      .catch((error) => {
        response = error.response;
      });
    // console.log("sendMobileOTP", response);
    if (response.status === 200) {
      return { data: response, error: null };
    } else return { data: null, error: response?.data?.message };
  } catch (err) {
    console.log(err);
  }
}
export async function verifyEmailOTP(data) {
  try {
    const response = await api.post("/user/otp_validation", data);
    if (response.status === 200) {
      return response;
    } else throw new Error("Could not verify OTP");
  } catch (err) {
    console.log(err);
  }
}

export async function deleteAccount() {
  try {
    const response = await api.delete("/user/delete_user_account");
    if (response.status === 200) {
      return response;
    } else throw new Error("Could not verify OTP");
  } catch (err) {
    console.log(err);
  }
}

export async function verifyEmailPassword(data) {
  try {
    const ssoResponse = await axios.post(`${constant.SSO_BASE_URL}/login`, {
      email: data?.user_email,
      password: data?.user_password,
      clientId: constant.SSO_CLIENT_ID,
    });

    const response = await api.post("/auth/sso-sync", {
      ssoToken: ssoResponse.data.token,
    });
    if (response.status === 200) {
      response.data.data = {
        ...response.data.data,
        ssoToken: ssoResponse.data.token,
      };
      return response;
    }
    else throw new Error("Could not verify OTP");
  } catch (err) {
    console.log(err);
    throw err
  }
}
export async function savepassword(data) {
  try {
    const response = await api.post("/user/1", data);
    if (response) {
      return response;
    } else throw new Error("Could not verify OTP");
  } catch (err) {
    console.log(err);
  }
}
export async function saveInfo(data) {
  try {
    const response = await api.post("/user/2", data);
    if (response) {
      return response;
    } else throw new Error("Could not verify OTP");
  } catch (err) {
    console.log(err);
  }
}
export async function saveOrg(data) {
  try {
    const response = await api.post("/user/3", data);
    return response.data;
  } catch (err) {
    console.log(err?.response?.data?.message);
    throw new Error(err?.response?.data?.message);
  }
}

export async function sendPasswordValidationOTPtoEmail(data) {
  try {
    let response;
    await api
      .post("/user/initiate-reset-password", data)
      .then((data) => {
        console.log(data);
        response = data;
      })
      .catch((error) => {
        response = error.response;
      });
    // console.log("sendMobileOTP", response);
    if (response.status === 200) {
      return { data: response, error: null };
    } else {
      console.log(response);
      return { data: null, error: response?.data?.message };
    }
  } catch (err) {
    console.log(err);
  }
}

export async function verifyResetPasswordOTP(data) {
  try {
    const response = await api.post(
      "/user/reset-password-opt-validation",
      data
    );
    if (response?.status === 200) {
      return response;
    } else throw new Error("Could not verify OTP");
  } catch (err) {
    console.log(err);
  }
}

export const resetPassword = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}api/user/reset-password`,
      data,
      {
        headers: {
          Authorization: `Bear ${localStorage.getItem("resetToken")}`,
        },
      }
    );
    console.log(response);
    if (response?.status === 200) {
      return response;
    } else throw new Error("error");
  } catch (err) {
    console.log(err.response.data.message);
    throw err;
  }
};
